/**
 * CycleWorkspaceRedirect
 *
 * Redirects /cycles/:cycleId/workspace back to the cycle detail page with
 * the workspace tab pre-selected (?tab=workspace). This keeps the full
 * cycle chrome (header, tabs, focus mode) visible — the workspace content
 * renders inline as a tab rather than navigating to a separate surface.
 */

import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export function CycleWorkspaceRedirect() {
  const { cycleId } = useParams<{ cycleId: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!cycleId) return;
    navigate(`/prioritization/cycles/${cycleId}?tab=tracks`, { replace: true });
  }, [cycleId, navigate]);

  return (
    <div className="flex items-center justify-center py-24 text-sm text-[var(--text-ter)]">
      Opening workspace…
    </div>
  );
}
